import { List, NeoModel, ValueObject } from "@singularsystems/neo-core";
import SecurityHoldingLookup from "../../Reports/Holdings/Models/Lookups/SecurityHoldingLookup";

@NeoModel
export default class DownloadHoldingsReportQuery extends ValueObject {
    public securityHoldingsFile = new List(SecurityHoldingLookup);
}